import type { Middleware } from '@reduxjs/toolkit';
import { configureStore } from '@reduxjs/toolkit';
import { FLUSH, PAUSE, PERSIST, persistStore, PURGE, REGISTER, REHYDRATE } from 'redux-persist';

import { baseApi } from '@shared/utils/api/configs/rtkBaseQueryDemo';

import { persistedReducer } from './rootReducer';

const middlewares: Middleware[] = [baseApi.middleware];

// The store has been created with these options:
// - the store is fully persisted
// - the Redux DevTools Extension is disabled for production
export const store = configureStore({
  devTools: process.env.NODE_ENV !== 'production',
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat(middlewares),
  reducer: persistedReducer,
});

export const persistor = persistStore(store);
